import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/layout";
import { HomePage } from "./pages/home-page";
import { GalleryPage } from "./pages/gallery-page";
import { ArtworkPage } from "./pages/artwork-page";
import { ContentPage } from "./pages/content-page";
import { AdminArtworkPage, AdminCatalogPage, AdminGate } from "./pages/admin-pages";
import {
  AddArtworkPage,
  CuratorArtworkPage,
  CuratorDashboardPage,
  CuratorExhibitionsPage,
  CuratorGate,
  CuratorGovernancePage
} from "./pages/curator-pages";
import { NotFoundPage } from "./pages/not-found-page";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="gallery/" element={<GalleryPage />} />
        <Route path="artwork/:id" element={<ArtworkPage />} />
        <Route path="catalog/item/:id" element={<ArtworkPage />} />
        <Route path="biography" element={<ContentPage slug="biography" />} />
        <Route path="biography/" element={<ContentPage slug="biography" />} />
        <Route path="patron" element={<ContentPage slug="patron" />} />
        <Route path="patron/" element={<ContentPage slug="patron" />} />
        <Route path="collectors-notice" element={<ContentPage slug="collectors-notice" />} />
        <Route
          path="patron/collectors-notice.php"
          element={<ContentPage slug="collectors-notice" />}
        />
        <Route path="marketing/event01.html" element={<ContentPage slug="event01" />} />
        <Route path="admin" element={<AdminGate />}>
          <Route index element={<AdminCatalogPage />} />
          <Route path="artwork/:id" element={<AdminArtworkPage />} />
        </Route>
        <Route path="curator" element={<CuratorGate />}>
          <Route index element={<CuratorDashboardPage />} />
          <Route path="add" element={<AddArtworkPage />} />
          <Route path="artwork/:id" element={<CuratorArtworkPage />} />
          <Route path="exhibitions" element={<CuratorExhibitionsPage />} />
          <Route path="governance" element={<CuratorGovernancePage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
